// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'center', p: '24px 16px 0px', mt: 'auto' }}>
      <Typography variant="caption">
        &copy; {new Date().getFullYear()}{' '}
        <Link href="https://accusmartmeters.com" target="_blank" underline="hover">
          AccuSmart Metering Solutions Inc.
        </Link>
        {' '}All rights reserved.
      </Typography>
    </Stack>
  );
}
